import axios from 'axios'
import { Campaign, CampaignPayload, DiscountVoucherApiPayload } from 'src/core/models'

export const getCampaingsAPI = async (): Promise<Campaign[]> => {
  const { data } = await axios.get<Campaign[]>('/api/v1/campaigns/')
  return data
}

export const createCampaingAPI = async (payload: CampaignPayload): Promise<CampaignPayload> => {
  const { data } = await axios.post<CampaignPayload>('/api/v1/campaigns/', payload)
  return data
}

export const createDiscountVOucherAPI = async (payload: DiscountVoucherApiPayload): Promise<string> => {
  const { data } = await axios.post('/api/v1/discount_vouchers/', payload)
  return data
}
